<template>
  <div v-if="training.title">
    <div class="text-xs-center pb-3">
      <img :src="imageUrl" alt="Logo" style="max-height: 300px">
    </div>
    <v-layout align-center justify-center wrap class="mb-4">
      <v-flex xs12 sm8>
        <h3>{{training.title}}</h3>
        <p v-html="training.description"></p>
        Deadline für Anmeldungen: {{training.deadline | stringToDate }}<br/>
        Veranstaltungsdatum: {{training.date | stringToDate }}<br/>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="my-4" v-if="Object.keys(trainingGuests).length > 0">
      <v-flex xs12 sm8>
        <h3>Angemeldete Teilnehmer:</h3>
        <span v-if="getTotalCapacity() !== Infinity">
          <b>Freie Plätze: {{ getCapacityLeft() }}/{{ getTotalCapacity() }}</b>
        </span>
        <v-list class="nobg">
          <v-list-tile @click="" v-for="(guest, key) in (trainingGuests)" :key="key">
            <v-list-tile-content>
              <v-list-tile-title>
                {{getGuestEmail(guest)}}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="!isPastDeadline">
              <v-icon color="error" @click="removeItem(guest.guestId)">cancel</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4"
              v-if="!isPastDeadline && getCapacityLeft() > 0 && uninvitedGuests.length > 0">
      <v-flex xs12 sm8>
        <h3>Ehemalige Teilnehmer anmelden</h3>
        <v-card>
          <v-card-text>
            <v-select
              prepend-icon="email"
              :items="uninvitedGuests"
              item-text="email"
              item-value="id"
              multiple
              v-model="newGuests"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <p v-if="newGuests.length > getCapacityLeft()" class="error--text">Nicht genügend freie Plätze!</p>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="primary" @click="addGuests" :loading="loading"
                   :disabled="newGuests.length > getCapacityLeft()">Anmelden
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4" v-if="!isPastDeadline && getCapacityLeft() > 0">
      <v-flex xs12 sm8>
        <h3>Neuen Teilnehmer anmelden</h3>
        <v-card>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs6>
                  <v-select
                    :items="genders"
                    v-model="newGuest.gender"
                    label="Anrede"
                    single-line
                    :disabled="loading"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Titel"
                    v-model="newGuest.title"
                    :disabled="loading"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Vorname"
                    v-model="newGuest.forename"
                    :disabled="loading"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Nachname"
                    v-model="newGuest.surname"
                    :disabled="loading"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Email"
                    required
                    :rules="emailRules"
                    v-model="newGuest.email"
                    :disabled="loading"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              color="primary"
              @click="createGuest"
              :loading="loading"
            >
              Gast Erstellen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="getCapacityLeft() <= 0">
      <v-flex class="text-xs-center">
        Alle Plätze sind bereits vergeben
      </v-flex>
    </v-layout>
    <v-layout v-if="isPastDeadline">
      <v-flex class="text-xs-center">
        Deadline ist bereits erreicht, Anmeldungen können nicht mehr geändert werden.
      </v-flex>
    </v-layout>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .nobg {
    background: none;
  }

  .list__tile__content {
    border-bottom: 1px solid #d3d3d3;
  }
</style>

<script>
  import {Storage} from 'aws-amplify';
  import {mapActions, mapGetters} from 'vuex';

  export default {
    props: ['trainingId', 'ceoId'],
    data() {
      return {
        user: {},
        imageUrl: '',
        isPastDeadline: false,
        newGuest: {company: this.ceoId, formal: true},
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
        newGuests: [],
        loading: false,
        valid: true,
        name: '',
        nameRules: [
          (v) => !!v || 'Dies ist ein Pflichtfeld',
        ],
        email: '',
        emailRules: [
          (v) => !!v || 'Dies ist ein Pflichtfeld',
          (v) => /.+@.+/.test(v) || 'E-mail ist ungültig',
        ],
      };
    },
    computed: {
      ...mapGetters({
        training: 'pub/ceo/training',
        trainingGuests: 'pub/ceo/trainingGuests',
        trainingCeo: 'pub/ceo/trainingCeo',
        companyGuests: 'pub/ceo/companyGuests',
        companyGuestsObject: 'pub/ceo/companyGuestsObject',
        guests: 'pub/ceo/companyGuests',
        savedGuests: 'pub/ceo/savedGuests',
      }),
      uninvitedGuests() {
        const uninvited =
          this.savedGuests.filter((guest) => this.trainingGuests.filter((el) => el.guestId === guest.id).length === 0);

        return uninvited
          .map((uninvitedGuest) => Object.assign({email: this.getGuestEmail(uninvitedGuest)}, uninvitedGuest));
      },
    },
    methods: {
      ...mapActions({
        startLoading: 'common/loader/start',
        stopLoading: 'common/loader/stop',
        storeReadTraining: 'pub/ceo/read',
        removeGuest: 'pub/ceo/removeGuest',
        storeAddGuests: 'pub/ceo/addGuests',
        storeCreateGuest: 'pub/ceo/createGuest',
      }),
      removeItem(guestId) {
        this.startLoading();
        this.removeGuest({guestId, trainingId: this.training.id, ceoId: this.ceoId}).then(() => {
          this.stopLoading();
          this.readTraining();
        });
      },
      getCapacityLeft() {
        let minCapacity = Infinity;
        if (this.training.capacity) {
          minCapacity = this.training.capacity - this.training.guestCount;
        }
        if (this.trainingCeo.capacity) {
          minCapacity = Math.min(minCapacity, this.trainingCeo.capacity - this.trainingGuests.length);
        }
        return minCapacity;
      },
      getTotalCapacity() {
        let capacity = Infinity;
        if (this.training.capacity) {
          capacity = this.training.capacity;
        }
        if (this.trainingCeo.capacity) {
          capacity = Math.min(capacity, this.trainingCeo.capacity);
        }
        return capacity;
      },
      createGuest() {
        if (this.$refs.form.validate()) {
          this.startLoading();
          this.storeCreateGuest({training: {id: this.trainingId}, ceoId: this.ceoId, guest: this.newGuest})
            .then(() => {
              this.newGuest = {company: this.ceoId, formal: true};
              this.$refs.form.reset();
              this.stopLoading();
              this.readTraining();
            });
        }
      },
      async readTraining() {
        this.startLoading();
        await this.storeReadTraining({ceoId: this.ceoId, trainingId: this.trainingId});
        this.stopLoading();
        const deadline = new Date(this.training.deadline);
        const now = new Date();
        this.isPastDeadline = now.getTime() > deadline.getTime();
      },
      addGuests() {
        this.startLoading();
        this.storeAddGuests({trainingId: this.training.id, ceoId: this.ceoId, guests: this.newGuests}).then(() => {
          this.stopLoading();
          this.newGuests = [];
          this.readTraining();
        });
      },
      getGuestEmail(trainingGuest) {
        let email = '';
        this.savedGuests.some((guest) => {
          if (guest.id === trainingGuest.guestId) {
            email = guest.email;
            return true;
          }
        });
        // for (let i = 0; i < this.savedGuests.length; i += 1) {
        //   if (this.savedGuests[i].id === trainingGuest.guestId) {
        //     return this.savedGuests[i].email;
        //   }
        // }

        return email;
      },
    },
    async mounted() {
      await this.readTraining();
      this.imageUrl = await Storage.get(this.training.logo);
    },
  };
</script>
